// @mui
import { makeStyles } from '@mui/styles'


export const topupOptionStyle = theme => ({
  amount: {
    lineHeight: theme.typography.caption.lineHeight,
    fontWeight: theme.typography.fontWeightBold,
  }
})

export const useTopupOptionStyle = makeStyles(topupOptionStyle)
